<template>
    <TheModal class="sm" @close="close">
        <template v-if="state === 'success'" slot="head">
            Платеж зачислен
        </template>

        <template v-if="state === 'fail'" slot="head">
            Ошибка платежа
        </template>

        <template v-if="state === 'success'">
            <p class="text-success">
                <strong>Спасибо! Ваш платеж зачислен.</strong>
            </p>

            <p>Историю начислений и списаний со счета вы можете проверить в разделе <i><router-link :to="{ name: 'profile' }">Профиль</router-link> &rarr; Биллинг</i></p>
        </template>

        <template v-if="state === 'fail'">
            <p class="text-danger">
                <strong>К сожалению, нам не удалось зачислить платеж.</strong>
            </p>

            <p>Это могло произойти из-за отсутствия связи с платежной системой, техническими неполадками, а также из-за того, что процесс платежа был прерван.</p>

            <p>Попробуйте повторить платеж в разделе <i><router-link :to="{ name: 'profile' }">Профиль</router-link> &rarr; Биллинг</i> чуть позже.</p>

            <p>Для решения любых вопросов, пожалуйста, свяжитесь с нашей <a href="https://telemetron.ru/contacts/feedback" target="_blank">службой поддержки</a>.</p>

            <p>
                <strong>E-mail</strong>: <a href="mailto:support@telemetron.ru">support@telemetron.ru</a>
            </p>
        </template>
    </TheModal>
</template>

<script>
import TheModal from '@/components/TheModal'

export default {
    components: {
        TheModal
    },

    props: {
        state: {
            type: String,
            default: 'success',
            validator(value) {
                return ['success', 'fail'].indexOf(value) !== -1
            }
        }
    },

    methods: {
        close() {
            this.$router.push({ name: 'profile' })
        }
    }
}
</script>
